import { DMCObject } from "./DMCObject";
import html2canvas from "html2canvas";
import Konva from "konva";

//PUT THE TEXT IN THIS OBJECT !
export class DMCText extends DMCObject {
  constructor(name, konvaObject, text) {
    super(name, konvaObject);
    this.previousText = "";
    this.text = text;
    this.color = "#ffffff";
  }

  createNewObject(DMCObject) {
    const options = DMCObject.konvaObjectOption;
    return new Konva.Image(options);
  }

  getType() {
    return "Text";
  }

  load(controllerProject, DMCObject, incorporate) {
    // We define the text before load call
    this.setText(DMCObject.text);
    super.load(controllerProject, DMCObject, incorporate);
    return this;
  }

  loadEnd(obj) {
    this.renderText().catch((err) => {
      console.error(err);
    });
    return obj;
  }

  options() {
    return ["RectPartial", "Text"];
  }

  /**
   * Create the DOM element that will be rendered
   * @param {String} htmlText
   * @returns DOM element
   */
  createTextElement(htmlText) {
    // Retrieve rendering element
    const element = document.getElementById("textRenderingToCanvas");

    if (element !== null) {
      const div = document.createElement("div");

      div.innerHTML = htmlText;
      div.style.color = this.color;

      element.appendChild(div);
      return div;
    } else {
      return null;
    }
  }

  /**
   * Render the text for Konva
   * @returns Promise
   */
  renderText() {
    const _this = this;

    return new Promise((resolve, reject) => {
      this.previousText = this.text;
      const textDiv = this.createTextElement(this.text);

      html2canvas(textDiv, {
        backgroundColor: null,
      })
        .then((canvas) => {
          _this.konvaObject.width(canvas.width);
          _this.konvaObject.height(canvas.height);
          _this.konvaObject.image(canvas);

          textDiv.remove();
          return resolve("Text widget updated");
        })
        .catch((err) => {
          return reject(err);
        });
    });
  }

  /**
   * Define the text
   * @param {String} text
   */
  setText(text) {
    this.text = text;
  }
}
